import { useContext } from 'react'
import { DebugCtx } from './context'

export function useDebugData() {
  const ctx = useContext(DebugCtx)
  if (!ctx) throw new Error('useDebugData must be used within DebugProvider')
  return ctx.data
}

export function useSetDebugData() {
  const ctx = useContext(DebugCtx)
  if (!ctx) throw new Error('useSetDebugData must be used within DebugProvider')
  return ctx.setDebugData
}
